import React, {useEffect, useMemo} from 'react';
import Container from '../common/layout/Container';
import {useTranslation} from 'react-i18next';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {setTitle} from '../../store/header/header.slice';
import {models} from 'powerbi-client';
import {PowerBIEmbed} from 'powerbi-client-react';
import {Redirect, useParams} from 'react-router-dom';
import Spinner from '../common/Spinner';
import {useReports} from '../../hooks/useReports';

type Params = {
  id: string
}

const DEFAULT_CONFIG = {
  type: 'report',
  tokenType: models.TokenType.Embed
};

const Reports = () => {
  const {id} = useParams<Params>();
  const {t} = useTranslation('navigation');
  const dispatch = useAppDispatch();

  const {reports} = useAppSelector((state) => state.permissions);

  const report = useMemo(() => reports
      ?.find(({id: reportId}) => id === reportId.toString()), [id]);

  const {
    embedConfig,
    isLoading,
    eventHandlers,
    handleSetReport
  } = useReports({
    initialConfig: DEFAULT_CONFIG,
    report
  });

  useEffect(() => {
    dispatch(setTitle(t('reports')));
  }, []);

  if (isLoading) {
    return (
      <Container>
        <Spinner />
      </Container>
    );
  }

  if (!report) {
    return <Redirect to="/" />;
  }

  const {displayName} = report || {};

  return (
    <Container header={displayName || ''}>
      <PowerBIEmbed
        embedConfig={embedConfig}
        eventHandlers={eventHandlers}
        cssClassName="report"
        getEmbeddedComponent={handleSetReport}
      />
    </Container>
  );
};

export default Reports;
